import {
  GetRegionsResponse,
  geographies,
  PostSuggestedGeographiesResponse,
  SearchGeographiesResponse,
} from '@api';
import { apiFetch, wretchRequest } from '@terminal/utils/api-fetch/apiFetch';

export const getRegions = (signal?: AbortSignal) =>
  wretchRequest<GetRegionsResponse>(geographies.getRegions.path, {
    schema: geographies.getRegions.schema,
    signal,
  });

export const searchGeographies = (
  query: string,
  limit?: number,
  signal?: AbortSignal
) =>
  wretchRequest<SearchGeographiesResponse>(
    geographies.searchGeographies.path(query, limit),
    {
      schema: geographies.searchGeographies.schema,
      signal,
    }
  );

export const postSuggestedGeographies = (
  entityTags: string[],
  signal?: AbortSignal
) =>
  wretchRequest<PostSuggestedGeographiesResponse>(
    geographies.postSuggested.path,
    {
      method: 'post',
      schema: geographies.postSuggested.schema,
      body: { entity_tags: entityTags },
      signal,
    }
  );

export const safePostSuggestedGeographies = (
  entityTags: string[],
  signal?: AbortSignal
) =>
  apiFetch<PostSuggestedGeographiesResponse>(geographies.postSuggested.path, {
    method: 'post',
    schema: geographies.postSuggested.schema,
    body: { entity_tags: entityTags },
    signal,
  });
